<template>
  <div class="prompt-placeholder" :class="{'prompt-placeholder--noimg': !placeholder}">
    <img :src="placeholder" alt="">
    <div class="prompt-placeholder-footer layout-flex">
      <span class="layout-flex_block--1" @click="cancle"></span>
      <span class="layout-flex_block--1" @click="confirm"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancle() {
      this.$emit('onCancel');
    },
    confirm() {
      this.$emit('onConfirm');
    },
  }
};
</script>

<style lang="stylus" scoped>
.prompt-placeholder {
  position relative;
  width: 295px;
  &.prompt-placeholder--noimg {
    height 346px;
  }
  .prompt-placeholder-footer  {
    position absolute;
    left 0;
    right: 0;
    bottom: 0;
    height 110px;
  }
  img {
    display block;
    width 100%;
    user-drag: none;
    user-select: none;
  }
}
</style>